import {useDispatch, useSelector} from "react-redux";
import {Navigate} from "react-router-dom";
import ConfirmationDialog from "../components/ConfirmationDialog";
import React, {useEffect, useState} from "react";
import {logOut} from "../redux/slices/authSlice";
import {timeNowInMinutes} from "../helpers/timeNowInMinutes";

const AuthGuard = ({children}) => {
    const {isLoggedIn} = useSelector((state) => state?.auth);
    const dispatch = useDispatch();
    const [openSessionDialog, setOpenSessionDialog] = useState(false);
    const [counterMsg, setCounterMsg] = useState(null);
    const END_SESSION_TIMEOUT_IN_MINUTES = 60;
    const WARNING_TIME_IN_MINUTES = 50;

    useEffect(() => {
        const intervalId = setInterval(() => {
            const storedSessionTimeoutInMinutes = parseInt(localStorage.getItem("sessionTimeout"), 10);
            console.log('Counter in seconds: ', timeNowInMinutes() - storedSessionTimeoutInMinutes)
            // Checking for handling Logout after  passing the waiting time
            if (END_SESSION_TIMEOUT_IN_MINUTES - (timeNowInMinutes() - storedSessionTimeoutInMinutes) <= 0)
                handleLogout()

            // Checking for updating the countdown timer of the dialog message
            if (END_SESSION_TIMEOUT_IN_MINUTES - (timeNowInMinutes() - storedSessionTimeoutInMinutes) <= 10)
                setCounterMsg(END_SESSION_TIMEOUT_IN_MINUTES - (timeNowInMinutes() - storedSessionTimeoutInMinutes))

            // Checking for appearing the warning dialog
            if (timeNowInMinutes() - storedSessionTimeoutInMinutes === WARNING_TIME_IN_MINUTES)
                setOpenSessionDialog(true);
        }, 2000)
        return () => clearInterval(intervalId)
    }, [])

    useEffect(() => {
        // stay active in all multi tabs open
        const handleStorage = (event) => {
            if (event.key === "logoutFromAllTabs") {
                localStorage.removeItem("sessionTimeout");
                localStorage.removeItem("logoutFromAllTabs"); // trigger event for multi tabs open
                dispatch(logOut());
            }
        };

        window.addEventListener("storage", handleStorage);
    }, []);

    const handleStayActive = () => {
        localStorage.setItem("sessionTimeout", timeNowInMinutes());
    }

    const handleLogout = () => {
        localStorage.setItem("logoutFromAllTabs", timeNowInMinutes()); // trigger event for multi tabs open
        dispatch(logOut());
    }

    return isLoggedIn ? <>
        <ConfirmationDialog
            title="Action Required"
            description={`You will be logged out in ${counterMsg} minutes.`}
            btnConfirmName={'Stay'}
            hasCancel={false}
            hasClose={false}
            open={openSessionDialog}
            onClose={(value, reason) => {
                if (reason === "backdropClick")
                    return;

                if (value) {
                    handleStayActive()
                } else {
                    handleLogout()
                }
                setOpenSessionDialog(false);
            }}
        />
        {children}
    </> : <Navigate to="/"/>;
};

export default AuthGuard;
